import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import type {ISettingsParam} from '@wix/tpa-settings'
import {
  isEventRsvpButtonVisible,
  isRegistrationClosed,
  isWithoutRegistration,
  ticketedOrInitiallyTicketed,
} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {useSettings} from '../../../../../commons/hooks/use-settings'
import settingsParams from '../../../settingsParams'
import {useWidgetActions, useWidgetState} from '../../hooks/state-provider'
import {hasEventDetailsUrl} from '../../selectors/events'
import {LinkToPage} from '../link-to-page'
import {RsvpButtonProps} from './interfaces'
import s from './rsvp-button.scss'

export const RsvpButton = ({
  event,
  dataHook = 'ev-rsvp-button',
  fullWidth,
  minWidth = 160,
  minHeight = 42,
  maxWidth,
  additionalStyle = {},
  containerClassName,
  className,
  calendar = false,
}: RsvpButtonProps) => {
  const {getWithFallback} = useSettings()
  const state = useWidgetState(st => st)
  const actions = useWidgetActions()

  const hasUrl = hasEventDetailsUrl(state, event)

  const visible = isEventRsvpButtonVisible(event)
  const text = getText(event, getWithFallback)

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    actions.navigateToPage({event})
  }

  const styles: React.CSSProperties = {
    minWidth,
    maxWidth,
    minHeight,
    ...additionalStyle,
  }
  const classes = classNames(s.button, className, {
    [s.calendar]: calendar,
    [s.fullWidth]: fullWidth,
    [s.link]: hasUrl,
  })

  return visible ? (
    <div className={containerClassName}>
      {hasUrl ? (
        <LinkToPage
          event={event}
          dataHook={dataHook}
          style={styles}
          className={classes}
          allowExternal
          dataAnchor={DH.eventDetails}
        >
          <span className={s.linkText}>{text}</span>
        </LinkToPage>
      ) : (
        <button data-hook={dataHook} style={styles} className={classes} type="button" onClick={onClick}>
          <span className={s.linkText}>{text}</span>
        </button>
      )}
    </div>
  ) : null
}

const getText = (
  event: wix.events.Event | Event_V3,
  getWithFallback: (param: ISettingsParam, fallbackParam: ISettingsParam) => any,
) => {
  const ticketed = ticketedOrInitiallyTicketed(event)
  const registrationClosed = isRegistrationClosed(event)
  const withoutRegistration = isWithoutRegistration(event)

  if (withoutRegistration) {
    return getWithFallback(settingsParams.multiNoRegButtonText, settingsParams.registrationClosedButtonText)
  }

  if (ticketed) {
    if (registrationClosed) {
      return getWithFallback(settingsParams.multiTicketedClosedBtnText, settingsParams.registrationClosedButtonText)
    } else {
      return getWithFallback(settingsParams.multiTicketedButtonText, settingsParams.listButtonText)
    }
  }

  if (registrationClosed) {
    return getWithFallback(settingsParams.multiRsvpClosedBtnText, settingsParams.registrationClosedButtonText)
  } else {
    return getWithFallback(settingsParams.multiRsvpButtonText, settingsParams.listButtonText)
  }
}
